<div>
	<table mat-table class="ob-table ob-table-plain no-link-decoration desktop-view breakpoint-md" matSort [dataSource]="dataSource" aria-label="table">
		<ng-container [matColumnDef]="COLUMN_TYPE">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.type" | translate }}</th>
			<td mat-cell *matCellDef="let element">
				<div class="cell">
					{{ element.type }}
				</div>
			</td>
		</ng-container>
		<ng-container [matColumnDef]="COLUMN_TITLE">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.title" | translate }}</th>
			<td class="cell" mat-cell *matCellDef="let element">
				{{ element.title }}
			</td>
		</ng-container>
		<ng-container [matColumnDef]="COLUMN_TEXT">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.text" | translate }}</th>
			<td mat-cell *matCellDef="let element">
				<app-multiline-text [text]="(element.text | fallback: currentLanguage) ?? '-'"></app-multiline-text>
			</td>
		</ng-container>
		<ng-container [matColumnDef]="COLUMN_URI">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.uri" | translate }}</th>
			<td mat-cell *matCellDef="let element">
				{{ element.uri }}
			</td>
		</ng-container>
		<ng-container [matColumnDef]="COLUMN_IDENTIFIER">
			<th mat-header-cell mat-sort-header *matHeaderCellDef>{{ "i18n.property.identifier" | translate }}</th>
			<td class="cell" mat-cell *matCellDef="let element">
				{{ element.identifier }}
			</td>
		</ng-container>
		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>

	<div class="mobile-view breakpoint-md">
		@for (element of dataSource.data; track element) {
			<div class="wrapper plain">
				<div class="row">
					<div class="label">{{ "i18n.property.type" | translate }}</div>
					<div class="value">{{ element.type }}</div>
				</div>
				<div class="row">
					<div class="label">{{ "i18n.property.title" | translate }}</div>
					<div class="value">{{ element.title }}</div>
				</div>
				<div class="row">
					<div class="label">{{ "i18n.property.text" | translate }}</div>
					<div class="value"><app-multiline-text [text]="(element.text | fallback: currentLanguage) ?? '-'"></app-multiline-text></div>
				</div>
				<div class="row">
					<div class="label">{{ "i18n.property.uri" | translate }}</div>
					<div class="value">{{ element.uri }}</div>
				</div>
				<div class="row">
					<div class="label">{{ "i18n.property.identifier" | translate }}</div>
					<div class="value">{{ element.identifier }}</div>
				</div>
			</div>
		}
	</div>

	<div class="table-info-box">
		<app-infobox-no-content [datasource]="dataSource.data"></app-infobox-no-content>
	</div>
</div>
